
import { FolderItemProps, RoleItemProps } from "apis";
import { AdminBreadcrumb } from "components";
import useAppForm from "hooks/useAppForm";
import { FC, Fragment, useState } from "react";
import { FormFolderValuesProps } from ".";
import AppForm from "components/AppForm";

interface FormFolderProps {
    onClose: () => void;
    initialValues?: FormFolderValuesProps;
    onSubmit: (values: FormFolderValuesProps) => void;
}
const FormFolder: FC<FormFolderProps> = ({ onClose, initialValues, onSubmit }) => {
    const form = useAppForm<FolderItemProps>(
        (initialValues || {}) as FolderItemProps,
        {
            name: { required: "Vui lòng nhập tên thư mục!" }
        }
    );
    const { values, errors, handleChange } = form;
    return (
        <Fragment>
            <AppForm
                form={form}
                onSubmit={() => {
                    onSubmit(values);
                }}
                shadow={false}
                noStyle
            >
                <AppForm.Input
                    value={values.name}
                    onChange={name => {
                        handleChange({ name })
                    }}
                    error={errors.name}
                    required
                    placeholder="Nhập tên thư mục..."
                />
                <AppForm.Action col={2}>
                    <button
                        type="button"
                        onClick={() => {
                            form.reset();
                            onClose();
                        }}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    >
                        Hủy
                    </button>
                    <button
                        type="submit"
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        Lưu
                    </button>
                </AppForm.Action>
            </AppForm>

        </Fragment>
    );
};
export default FormFolder;
